import {memo, useCallback,useContext,useEffect,useState} from 'react';
import { Box,Grid,Skeleton,Button } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {useCubeQuery } from '@cubejs-client/react';
import { styled } from '@mui/material/styles';

import TableChart from '../../components/chartComponents/TableChart';
import { createMarkup, updateQuery } from '../../utils/Reusables';
import EmptyChartNew from './EmptyChartNew';
import ReportFilterPopup from './ReportFilterPopup';
import BarChartNew from '../../components/chartComponents/BarChartNew';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
}));

const ReportGraphNew = ({query,reportDetails}) => {    
    const [defaultQuery,setDefaultQuery] = useState({...query})
    const [prevData,setPrevData] = useState([])    
    const [currPage,setCurrentPage] = useState(query.offset && query.limit  ? (query.offset)/query.limit : 0)
    

    const {isLoading,resultSet,error,progress,refetch} = useCubeQuery(defaultQuery,{resetResultSetOnChange:false});
    //console.log(error)

    const handleQueryChange = useCallback((newQuery) => {
        //console.log(defaultQuery,newQuery)
        setDefaultQuery({...defaultQuery,...newQuery})
    })

    const renderChart = useCallback((chartType) => {
        //console.log(chartType)
        switch(chartType){
            case 'table':
                return <TableChart isLoading={isLoading} currPage={currPage} changeCurrentPage={setCurrentPage} resultSet={resultSet} handlePrevData={setPrevData} prevData={prevData} query={defaultQuery} updateQuery={handleQueryChange} reportDetails={reportDetails}/>
            case 'bar':
                return <BarChartNew isLoading={isLoading} resultSet={resultSet} query={defaultQuery} updateQuery={handleQueryChange} reportDetails={reportDetails}/>
            default:
                return <div>Report Content</div>
        }
    })

    const tableDataReset = useCallback(() => {
        if(prevData.length > 0) {
            setPrevData([])
            setCurrentPage(0)
        }
    })

    useEffect(() => {
        tableDataReset()
        setDefaultQuery({...query})
    },[query.meassures,query.dimensions,query.filters,query.timeDimensions,query.limit,query.order])
    
    useEffect(() => {
        tableDataReset()
        setDefaultQuery({...defaultQuery,limit: query.limit,offset: 0})
    },[defaultQuery.order])

    useEffect(() => {

        //unmount function for component
        return () => {
            console.log('Unmount Report Graph Component')
            setDefaultQuery(null)
        }
    },[])

    if(prevData.length == 0 && isLoading){
        return <Box className="width-100">
            <Skeleton className='progress-skeleton' animation="wave" />
            <Skeleton className='progress-skeleton half' animation="wave" />
            <Skeleton className='progress-skeleton quarter' animation="wave" />
        </Box>
    }
    return <Grid style={{position:'relative'}}>
        {
            (reportDetails && reportDetails.fields && defaultQuery && ((defaultQuery.measures && defaultQuery.measures.length > 0) || (defaultQuery.dimensions && defaultQuery.dimensions.length > 0))) ?
                <>
                    {
                        reportDetails && reportDetails.filters && reportDetails.filters.filter(obj => obj.onReport).length > 0 &&
                        <ReportFilterPopup 
                            reportDetails={reportDetails}
                            query={query}
                            updateQuery={handleQueryChange}
                        />                           
                    }
                    {
                        error ?
                            <HtmlTooltip
                                title={
                                    <>
                                        <div style={{ color: '#f45e29' }} dangerouslySetInnerHTML={createMarkup(error.message)} />
                                    </>
                                }
                            >
                                <Button>Something Went Wrong, Please contact Administrator, if problem persists</Button>
                            </HtmlTooltip>
                        :
                        resultSet ? 
                            renderChart(reportDetails.chartType) 
                        :
                            <EmptyChartNew />
                        
                    }
                </>
            :
            <EmptyChartNew />
        }        
    </Grid>
     
}

export default memo(ReportGraphNew)